// VAPID application server public key (base64url, uncompressed P-256 point).
// PUBLIC by design — this is shipped to every browser as applicationServerKey.
// The matching private key lives only in the Sentinel backend (.env).
export const VAPID_PUBLIC_KEY =
  'BDfQdSTDpakbtFd81h8AUpbwyNVLSakGOIL3rKMS6vQQFcd2svgBKhjVzYVyx43YNlLEmciCQDv19hHne5VwzPQ'
